export enum AlarmSettingValidationErrors {
    NOT_WITHIN_MEASURABLE_RANGE = 'errors.alarm-setting.validation.not-in-measurable-range',
    NOT_BELOW_LOW_ALARM = 'errors.alarm-setting.validation.not-below-low-alarm',
    NOT_ABOVE_VERY_LOW_ALARM = 'errors.alarm-setting.validation.not-above-very-low-alarm',
    NOT_BELOW_NORMAL_RANGE = 'errors.alarm-setting.validation.not-below-normal-range',
    NOT_ABOVE_NORMAL_RANGE = 'errors.alarm-setting.validation.not-above-normal-range',
    NOT_BELOW_VERY_HIGH_ALARM = 'errors.alarm-setting.validation.not-below-very-high-alarm',
    NOT_ABOVE_HIGH_ALARM = 'errors.alarm-setting.validation.not-above-high-alarm',
}
